import { Portal } from '@radix-ui/react-dialog'
import type { ComponentPropsWithoutRef } from 'react'

type PortalProps = ComponentPropsWithoutRef<typeof Portal>

export interface SheetPortalProps extends PortalProps {
  forceMount?: PortalProps['forceMount']
  container?: PortalProps['container']
}

export const SheetPortal = Portal
